import { extend } from 'vee-validate';
import { required, email, confirmed } from 'vee-validate/dist/rules';

extend('email', email);
extend('required', required);
extend('confirmed', confirmed);

// Con la versión Vee-validate 3 hay que indicar, o extender, cada regla que se quiera usar en la aplicación
// Esto mejora el tamaño de los bundles, dado que solo se contiene los que se van a usar

// Al extender se puede redefinir aspectos como el mensaje a mostrar o una función para indicar como se debe hacer la validación
// Explicación más detallada en su web
// https://logaretm.github.io/vee-validate/guide/rules.html#importing-the-rules

